import type { IconData } from '@stacksjs/iconify-core'

export const interfaceEssentialBin: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M25.905 8.38v16.76h1.53V8.38h3.04V6.86h-1.52V5.33h-6.1V2.28h-1.52v3.05h-10.67V2.28h-1.52v3.05h-6.09v1.53h-1.53v1.52h3.05v16.76h1.52V8.38zm-1.52 16.76h1.52v4.57h-1.52Zm-16.76 4.57h16.76v1.53H7.625Z\"/><path fill=\"currentColor\" d=\"M21.335 11.43h1.52v12.19h-1.52Zm-1.52 12.19h1.52v3.04h-1.52Zm-4.57-12.19h1.52v15.23h-1.52ZM10.665.76h10.67v1.52h-10.67Zm0 22.86h1.53v3.04h-1.53Zm-1.52-12.19h1.52v12.19h-1.52Zm-3.05 13.71h1.53v4.57h-1.53Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default interfaceEssentialBin
